const apiUrlTable = {
  local: '',
  dev: 'https://kq.emodor.com',
  release: 'https://h5.emodor.com',
};

export const apiUrl = apiUrlTable.local;

export default {
  apiUrl,
};
